(() => {
  if (!document.body.classList.contains('template-index')) return;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new Set();
  let observer, hero, media, copy, frame = 0;
  const reveal = element => {
    element.classList.add('is-revealed');
    pending.delete(element);
    observer?.unobserve(element);
  };
  const refreshHero = () => {
    hero = document.querySelector('.hero');
    media = hero?.querySelector('.hero__media');
    copy = hero?.querySelector('.hero__content');
  };
  const paint = () => {
    frame = 0;
    if (!hero || preference.matches) return;
    const bounds = hero.getBoundingClientRect();
    const progress = Math.min(1, Math.max(0, -bounds.top / bounds.height));
    media.style.transform = `scale(${1 + progress * .045})`;
    copy.style.transform = `translate3d(0,${-progress * 36}px,0)`;
    hero.classList.toggle('is-scroll-active', progress > 0 && progress < 1);
  };
  const requestPaint = () => {
    if (!frame && !preference.matches) frame = requestAnimationFrame(paint);
  };
  const prepare = scope => {
    refreshHero();
    if (preference.matches || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, { rootMargin: '0px 0px -48px 0px', threshold: 0 });
    const selectors = '.w-section-head, .m-category-tile, .m-story-image, .m-story-copy > *, .w-footer-layout > *, .w-newsletter, .w-footer-bottom';
    const items = [...scope.querySelectorAll(selectors)].filter(el => !el.hasAttribute('data-scroll-reveal'));
    const viewport = innerHeight;
    const positions = items.map(el => ({el, top: el.getBoundingClientRect().top}));
    positions.forEach(({el, top}) => {
      el.setAttribute('data-scroll-reveal', el.matches('.m-story-image') ? 'image' : 'item');
      if (el.matches('.m-category-tile, .m-story-copy > *, .w-footer-layout > *')) {
        const order = [...el.parentElement.children].indexOf(el);
        el.style.setProperty('--reveal-delay', `${Math.min(order, 3) * 75}ms`);
      }
      if (top < viewport - 24 || el.contains(document.activeElement)) {
        el.classList.add('is-revealed');
      } else {
        pending.add(el);
        observer.observe(el);
      }
    });
    requestPaint();
  };
  addEventListener('scroll', requestPaint, {passive: true});
  addEventListener('resize', requestPaint, {passive: true});
  addEventListener('pageshow', requestPaint);
  document.addEventListener('focusin', event => {
    const element = event.target.closest('[data-scroll-reveal]');
    if (element) reveal(element);
  });
  preference.addEventListener('change', () => {
    if (preference.matches) {
      pending.forEach(reveal);
      observer?.disconnect();
      observer = null;
      cancelAnimationFrame(frame);
      frame = 0;
      if (media) media.style.removeProperty('transform');
      if (copy) copy.style.removeProperty('transform');
      hero?.classList.remove('is-scroll-active');
    } else {
      prepare(document);
    }
  });
  document.addEventListener('shopify:section:load', event => prepare(event.target));
  document.addEventListener('shopify:section:unload', event => {
    pending.forEach(el => {
      if (event.target.contains(el)) {
        observer?.unobserve(el);
        pending.delete(el);
      }
    });
    refreshHero();
  });
  document.addEventListener('shopify:section:select', event => {
    event.target.querySelectorAll('[data-scroll-reveal]').forEach(reveal);
  });
  prepare(document);
})();
